lib(
  (function () {
    var $form;
    var sectionSet = new SectionSet();
    var state = new State(sectionSet);

    function init() {
      initState();
      registerEvents();
    }

    function initState() {
      var emailSection, passwordSection;

      $form = $('#sign_in_form');

      emailSection = new Section({
        container: '#email_section',
        textField: '#user_email',
        submitButton: '#submit_email_button',
        errorContainer: '#submit_email_error',
        validationMessage: 'Please enter your email',
        beforeShow: function () {
          passwordSection.clear();
        },
      });

      passwordSection = new Section({
        container: '#password_section',
        textField: '#user_password',
        submitButton: '#submit_password_button',
        errorContainer: '#submit_password_error',
        validationMessage: 'Please enter your password',
        beforeShow: function () {
          $('#email_display').text(emailSection.value());

          displaySsoRedirectButton(
            $form.attr('data-org-soft-enabled'),
            $form.attr('data-sso-without-subdomain-feature-flag-enabled'),
            $form.attr('data-idp-url')
          );
        },
      });

      sectionSet.addSection('email', emailSection);
      sectionSet.addSection('password', passwordSection);

      state.initMode($form.attr('data-mode'));
    }

    function registerEvents() {
      $form.validateOn('submit', validate, submit, { scroll: false });
      $('#back_to_email_form').on('click', goBack);

      function goBack() {
        state.switchToMode('email');

        if ($('.button-wrapper').is(':hidden')) {
          $('.button-wrapper').show();
          $('.sso-soft-enabled-button-wrapper').hide();
        }
      }
    }

    function validate() {
      return state.section.validator();
    }

    function submit() {
      var section = state.section;
      section.clearError();
      section.enableSubmitState();

      $form.attr('action', section.submitPath());

      Ajax.submit({
        formSelector: $form,
        disableFlash: true,
        success: onSuccess,
        error: onError,
      });

      return false;
    }

    function onSuccess(response) {
      if (response && response.goto) {
        return;
      }

      if (state.mode === 'email') {
        state.section.disableSubmitState();
        state.switchToMode('password');

        displaySsoRedirectButton(
          response.org_soft_enabled,
          response.sso_without_subdomain_enabled,
          response.idp_url
        );
      }
    }

    function onError(response, xhr) {
      var message = getErrorMessage(response, xhr);
      state.section.setError(message);
      state.section.disableSubmitState();
    }

    function getErrorMessage(response, xhr) {
      if (response && response.status) {
        if (response.invited) {
          return Message.Login.AlreadyInvited;
        } else if (response.locked) {
          return Message.Login.UserLocked;
        } else {
          return Message.Login.InvalidCredentials;
        }
      } else if (xhr && xhr.status === 429) {
        return Message.Login.TooManyRequests;
      } else {
        return Message.Login.Error;
      }
    }

    function displaySsoRedirectButton(
      orgSoftEnabled,
      ssoWithoutSubdomainEnabled,
      idpUrl
    ) {
      if (orgSoftEnabled && ssoWithoutSubdomainEnabled) {
        $('.button-wrapper').hide();
        $('.sso-soft-enabled-button-wrapper').show();
        $('#continue-to-sso').attr('href', idpUrl);
      }
    }

    // Encapsulates a section of a form that has a single, required text field.
    //
    // The section container must have a submit-path data attribute.
    //
    // Required options:
    //   - container: a selector for the section container
    //   - textField: a selector for the text field
    //   - submitButton: a selector for the submit button
    //   - errorContainer: a selector for the error message container
    //   - validationMessage: a message to display when the text field is left blank
    //
    // Optional options:
    //   - beforeShow: function to call when this section is activated
    //
    function Section(options) {
      this.$container = $(getRequiredOption('container'));
      this.$textField = $(getRequiredOption('textField'));
      this.$submitButton = $(getRequiredOption('submitButton'));
      this.$errorContainer = $(getRequiredOption('errorContainer'));
      this.validationMessage = getRequiredOption('validationMessage');
      this.beforeShow = options.beforeShow || _.noop;

      function getRequiredOption(name) {
        if (options[name]) {
          return options[name];
        } else {
          throw 'Missing required option: ' + name;
        }
      }
    }

    _.extend(Section.prototype, {
      value: function () {
        return this.$textField.val();
      },

      clear: function () {
        this.$textField.val('');
        this.clearError();
      },

      focus: function () {
        this.$textField.focus();
      },

      validator: function () {
        var validator = new Validator();
        validator
          .validate(this.$textField)
          .withMessage(this.validationMessage)
          .notBlank();
        return validator;
      },

      submitPath: function () {
        return this.$container.data('submit-path');
      },

      enableSubmitState: function () {
        this.$submitButton.addClass('loading');
      },

      disableSubmitState: function () {
        this.$submitButton.removeClass('loading');
      },

      setError: function (message) {
        this.$errorContainer.text(message);
        this.$errorContainer.show();
      },

      clearError: function () {
        this.setError('');
        this.$errorContainer.hide();
      },

      hide: function () {
        this.$container.hide();
      },

      show: function () {
        this.beforeShow();
        // Don't use .show() here. If the element has no "display" attribute, .show() does nothing. But
        // the password section is given "display: none" in our CSS, which will not be changed with .show()
        this.$container.css('display', 'block').focus();
        this.focus();
      },

      // Swaps this section with another by sliding them sideways.
      // Accepts a slide direction of 'left' or 'right'.
      swapWith: function (otherSection, direction, onComplete) {
        this.$container.hide(
          'slide',
          { direction: direction },
          100,
          function () {
            otherSection.$container.show(
              'slide',
              { direction: direction === 'right' ? 'left' : 'right' },
              100,
              onComplete
            );
          }
        );
      },
    });

    function State(sectionSet) {
      this.sectionSet = sectionSet;
    }
    _.extend(State.prototype, {
      setMode: function (mode) {
        this.mode = mode;
        this.section = this.sectionSet.sections[mode];
      },

      initMode: function (mode) {
        if (mode !== this.mode) {
          this.setMode(mode);
          this.sectionSet.showSection(mode);
        }
      },

      switchToMode: function (mode) {
        if (mode !== this.mode) {
          this.sectionSet.switchToSection(mode);
          this.setMode(mode);
        }
      },
    });

    function SectionSet() {
      this.sections = {};
      this.positions = {};
      this.sectionCount = 0;
    }
    _.extend(SectionSet.prototype, {
      addSection: function (mode, section) {
        this.sectionCount++;
        this.sections[mode] = section;
        this.positions[mode] = this.sectionCount;
      },

      showSection: function (mode) {
        _.each(this.sections, function (section, sectionMode) {
          if (sectionMode === mode) {
            section.show();
          } else {
            section.hide();
          }
        });
      },

      switchToSection: function (mode) {
        var newSection = this.sections[mode],
          direction =
            this.positions[mode] > this.positions[state.mode]
              ? 'left'
              : 'right';

        newSection.beforeShow();
        this.sections[state.mode].swapWith(
          newSection,
          direction,
          newSection.focus.bind(newSection)
        );
      },
    });

    return {
      init: init,
    };
  })()
);
